
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"7","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.727 11.195a5.653 5.653 0 00-.149-.82 6.966 6.966 0 00-.203-.61l-.633-1.554h-.187L3.242 11H.844v-.367l.734-1.375c.484 0 .836-.018 1.055-.055.255-.042.466-.125.633-.25.187-.135.375-.367.562-.695.214-.38.373-.784.477-1.211.12-.495.18-1.042.18-1.64 0-.548-.032-.943-.094-1.188a1.207 1.207 0 00-.313-.594c-.146-.156-.362-.27-.648-.344l-.633-.164a3.044 3.044 0 01-.586-.21 1.241 1.241 0 01-.336-.243.84.84 0 01-.172-.305 1.867 1.867 0 01-.055-.515c0-.5.102-.964.305-1.39h.469c.031.244.101.426.21.546.11.115.316.2.618.258l.727.14c.296.058.533.133.71.227a.975.975 0 01.399.32c.088.125.148.282.18.47.036.187.054.457.054.812v2.132c0 .422.042.8.125 1.133.089.328.25.696.485 1.102.307.531.518.958.633 1.281.12.318.18.612.18.883 0 .234-.04.463-.118.687a3.133 3.133 0 01-.422.75h-.476z","fill":"currentColor"}})])
          )
        }
      }
    